// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryBalloons_root__A-yA6"};